import { getMessagesBlockedRedirect, normalizeUserRole } from './messagesAccess'
import { isCurrentListingPublished } from './currentListingContext'

/**
 * Recommended Buyers is visible to admins, sellers, and advisors/brokers.
 * Sellers and advisors need a published selected deal; admins always have access.
 */
export function canAccessBuyerOutreachPages(parsedUser, options = {}) {
  const role = normalizeUserRole(parsedUser?.role)
  if (role === 'admin') return true
  if (role === 'seller' || role === 'advisor' || role === 'broker') {
    const published = options.currentListingPublished ?? isCurrentListingPublished()
    return published
  }
  return false
}

export function isBuyerOutreachHiddenForUser(parsedUser, options = {}) {
  return !canAccessBuyerOutreachPages(parsedUser, options)
}

export function getBuyerOutreachBlockedRedirect(role) {
  const normalized = normalizeUserRole(role)
  if (normalized === 'seller') {
    return '/seller-dashboard'
  }
  if (normalized === 'broker' || normalized === 'advisor' || normalized === 'admin') {
    return '/advisor-dashboard'
  }
  return getMessagesBlockedRedirect(role)
}
